import { URIFormat } from '../enums/uri_format';
/**
 * Encodes a component according to a URIformat.
 *
 * @param component - A component string.
 * @param format - A URIformat.
 * @returns An encoded component string.
 */
export function encodeComponent(component, format) {
    if (!component) {
        return '';
    }
    let encodedComponent = encodeURIComponent(component);
    if (format === URIFormat.URI) {
        encodedComponent = encodedComponent.replace(/%20/g, '+');
    }
    // Encode characters that are not encoded by default by encodeURIComponent but
    // that the Spotify URI spec encodes: !'*()
    encodedComponent = encodedComponent.replace(/[!'()]/g, escape);
    encodedComponent = encodedComponent.replace(/\*/g, '%2A');
    return encodedComponent;
}
/**
 * Encodes an array of components according to a URIformat.
 *
 * @param components - An array of component strings to be encoded.
 * @param format - A URIformat to be used when encoding components.
 * @param target - A array that will be used to place component strings after encoding.
 * @returns An array of encoded component strings.
 */
export function encodeComponents(components, format, target = []) {
    for (let i = 0, len = components.length; i < len; ++i) {
        target.push(encodeComponent(components[i], format));
    }
    return target;
}
/**
 * Decodes a component according to a URIformat.
 *
 * @param component - An encoded component string.
 * @param format - A URIformat.
 * @returns An decoded component string.
 */
export function decodeComponent(component, format) {
    if (!component) {
        return '';
    }
    const part = format === URIFormat.URI ? component.replace(/\+/g, '%20') : component;
    return decodeURIComponent(part);
}
export function encodeQueryString(values) {
    let str = '?';
    for (const key in values) {
        if (Object.prototype.hasOwnProperty.call(values, key) &&
            values[key] !== undefined) {
            if (str.length > 1) {
                str += '&';
            }
            const value = values[key];
            if (typeof value !== 'undefined') {
                str += `${key}=${encodeURIComponent(value)}`;
            }
        }
    }
    return str;
}
const localeMatcher = /^intl-[A-Za-z]{2,3}(-[A-Za-z]{4})?(-([A-Za-z]{2}|[0-9]{3}))?$/;
export function matchLocale(component) {
    return localeMatcher.test(component);
}
//# sourceMappingURL=helpers.js.map